import React, { useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { HeaderDescriptionProps } from './types';
import { HeaderDescriptionContainer, Description, Overline, Title } from './styles';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';

const HeaderDescription: React.FC<HeaderDescriptionProps> = ({
  headline,
  description,
  testId,
  overline,
}) => {
  const { actualTheme } = useContext(ThemeContext);
  if (!headline) {
    throw new Error('The HeaderDescription component must have a headline.');
  }
  return (
    <ThemeProvider theme={actualTheme}>
      <HeaderDescriptionContainer data-testid={testId}>
        <Overline data-testid={`${testId}-overline`}>{overline}</Overline>
        <Title data-testid={`${testId}-title`}>{headline}</Title>
        <Description data-testid={`${testId}-description`}>{description}</Description>
      </HeaderDescriptionContainer>
    </ThemeProvider>
  );
};

export default HeaderDescription;
